import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Protected } from "@/components/common";
import AppLayout from "@/components/layout/AppLayout";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import TemplateDetail from "@/pages/TemplateDetail";
import { Checkout, PaymentCallback, TestPayment } from "@/pages/Checkout";
import { Login, Register, ForgotPassword, ResetPassword, VerifyEmail } from "@/pages/AuthPages";
import { Purchases, Favorites, Orders, Notifications } from "@/pages/Account";
import Profile from "@/pages/Profile";
import SellerLayout from "@/pages/seller/SellerLayout";
import SellerOverview from "@/pages/seller/SellerOverview";
import SellerTemplates from "@/pages/seller/SellerTemplates";
import UploadTemplate from "@/pages/seller/UploadTemplate";
import { SellerWallet, Withdraw, SellerTransactions, SellerSales } from "@/pages/seller/SellerMoney";
import SellerSettings from "@/pages/seller/SellerSettings";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const P = (el, role) => <Protected role={role}>{el}</Protected>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/template/:id" element={<TemplateDetail />} />
            <Route path="/checkout/:id" element={P(<Checkout />)} />
            <Route path="/payment/callback" element={P(<PaymentCallback />)} />
            <Route path="/payment/test" element={P(<TestPayment />)} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/purchases" element={P(<Purchases />)} />
            <Route path="/favorites" element={P(<Favorites />)} />
            <Route path="/orders" element={P(<Orders />)} />
            <Route path="/notifications" element={P(<Notifications />)} />
            <Route path="/profile" element={P(<Profile />)} />
            <Route path="/seller" element={P(<SellerLayout />)}>
              <Route index element={<SellerOverview />} />
              <Route path="templates" element={<SellerTemplates />} />
              <Route path="upload" element={<UploadTemplate />} />
              <Route path="sales" element={<SellerSales />} />
              <Route path="wallet" element={<SellerWallet />} />
              <Route path="withdraw" element={<Withdraw />} />
              <Route path="transactions" element={<SellerTransactions />} />
              <Route path="settings" element={<SellerSettings />} />
            </Route>
            <Route path="/admin" element={P(<AdminDashboard />, "admin")} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
